import { createContext, useContext, useEffect, useMemo, useState } from "react";
import en from "./en.json";
import ch from "./ch.json";
import my from "./my.json";
import ApiService from "../../components/Api_services";

const LANGUAGES = { en, ch, my };

const PRODUCT_NAME_MAP = {
  "Air Conditioners": {
    en: "Air Conditioners",
    ch: "空调",
    my: "Penghawa Dingin",
  },
  "Water Heaters": {
    en: "Water Heaters",
    ch: "热水器",
    my: "Pemanas Air",
  },
};

const localizeProductName = (productName, lang) => {
  const mapped = PRODUCT_NAME_MAP[productName];
  if (!mapped) return productName;
  return mapped[lang] || productName;
};

const applyProductName = (dict, productName) => {
  if (!productName) return dict;

  return Object.fromEntries(
    Object.entries(dict).map(([key, value]) => [
      key,
      typeof value === "string"
        ? value.replaceAll("{product_name}", productName)
        : value,
    ]),
  );
};

const LanguageContext = createContext({
  trans: en,
  lang: "en",
  setLanguage: () => {},
});

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(localStorage.getItem("afs-lang") || "en");
  const [productName, setProductName] = useState("");

  const setLanguage = (code) => {
    setLang(code);
    localStorage.setItem("afs-lang", code);
  };

  useEffect(() => {
    const fetchProductName = async () => {
      const mainItemCode = localStorage.getItem("mainItemCode");
      if (!mainItemCode) return;

      try {
        const productRes = await ApiService.getProductInfo(mainItemCode);
        if (productRes?.status === 200) {
          setProductName(productRes.data?.product_name || "");
        }
      } catch (error) {
        console.error("Error fetching product name:", error);
      }
    };

    fetchProductName();
    window.addEventListener("mainItemCodeUpdated", fetchProductName);
    return () =>
      window.removeEventListener("mainItemCodeUpdated", fetchProductName);
  }, []);

  const trans = useMemo(
    () =>
      applyProductName(
        LANGUAGES[lang] || en,
        localizeProductName(productName, lang),
      ),
    [lang, productName],
  );

  return (
    <LanguageContext.Provider value={{ trans, lang, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
